import CarpenterIcon from '@mui/icons-material/Carpenter';
import EngineeringIcon from '@mui/icons-material/Engineering';
import GroupsIcon from '@mui/icons-material/Groups';

export const jobs = [
  {
    id: 1,
    title: 'Trockenbaumonteur (m/w/d)',
    type: 'Vollzeit',
    location: 'München & Umgebung',
    icon: CarpenterIcon,
    description: 'Wir suchen erfahrene Trockenbaumonteure für unsere Projekte in München und Umgebung.',
    requirements: [
      'Abgeschlossene Ausbildung im Trockenbau oder vergleichbar',
      'Mindestens 2 Jahre Berufserfahrung',
      'Führerschein Klasse B',
      'Teamfähigkeit und Zuverlässigkeit',
      'Gute Deutschkenntnisse',
    ],
    benefits: [
      'Überdurchschnittliche Vergütung',
      'Firmenwagen zur privaten Nutzung',
      'Modernes Werkzeug & Ausstattung',
      'Weiterbildungsmöglichkeiten',
      '30 Tage Urlaub',
    ],
  },
  {
    id: 2,
    title: 'Bauleiter / Projektleiter (m/w/d)',
    type: 'Vollzeit',
    location: 'München',
    icon: EngineeringIcon,
    description: 'Zur Verstärkung unseres Teams suchen wir einen erfahrenen Bauleiter / Projektleiter.',
    requirements: [
      'Studium im Bauingenieurwesen oder Meister im Bauhandwerk',
      'Mehrjährige Erfahrung in der Bauleitung',
      'Sicherer Umgang mit MS Office & Projektmanagement-Tools',
      'Führerschein Klasse B',
      'Organisationsstärke und Durchsetzungsvermögen',
    ],
    benefits: [
      'Attraktives Gehalt + Bonus',
      'Firmenwagen',
      'Eigenverantwortliches Arbeiten',
      'Aufstiegsmöglichkeiten',
      'Betriebliche Altersvorsorge',
    ],
  },
  {
    id: 3,
    title: 'Maler und Lackierer (m/w/d)',
    type: 'Vollzeit',
    location: 'München & Umgebung',
    icon: CarpenterIcon,
    description: 'Für unsere wachsende Projektanzahl suchen wir motivierte Maler und Lackierer.',
    requirements: [
      'Abgeschlossene Ausbildung als Maler und Lackierer',
      'Erfahrung mit Spachteltechniken',
      'Sorgfältige und qualitätsbewusste Arbeitsweise',
      'Führerschein Klasse B',
      'Teamfähigkeit',
    ],
    benefits: [
      'Überdurchschnittliche Vergütung',
      'Firmenwagen möglich',
      'Modernes Werkzeug',
      'Weiterbildung',
      'Kollegiales Team',
    ],
  },
];

export const companyBenefits = [
  {
    icon: '💰',
    title: 'Faire Vergütung',
    description: 'Überdurchschnittliche Bezahlung und leistungsgerechte Prämien.',
  },
  {
    icon: '🚗',
    title: 'Firmenwagen',
    description: 'Firmenwagen auch zur privaten Nutzung möglich.',
  },
  {
    icon: '📚',
    title: 'Weiterbildung',
    description: 'Regelmäßige Schulungen und Weiterbildungsmöglichkeiten.',
  },
  {
    icon: '👥',
    title: 'Starkes Team',
    description: 'Kollegiales Arbeitsumfeld und flache Hierarchien.',
  },
  {
    icon: '🛡️',
    title: 'Sicherheit',
    description: 'Unbefristete Arbeitsverträge und betriebliche Altersvorsorge.',
  },
  {
    icon: '⏰',
    title: 'Work-Life-Balance',
    description: '30 Tage Urlaub und geregelte Arbeitszeiten.',
  },
];

export const teamValues = [
  {
    icon: GroupsIcon,
    title: 'Teamgeist',
    description: 'Bei uns arbeiten alle Hand in Hand — vom Azubi bis zum Geschäftsführer.',
  },
  {
    icon: EngineeringIcon,
    title: 'Qualität',
    description: 'Wir setzen auf höchste Qualität in jedem Projekt — ohne Kompromisse.',
  },
  {
    icon: CarpenterIcon,
    title: 'Handwerk',
    description: 'Wir sind stolz auf unser Handwerk und leben traditionelle Werte.',
  },
];
